export const all = ['tripPlannerUserSettings'] as const
export const settings = (loggedIn: boolean) => [...all, loggedIn] as const
